import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Plyr from 'plyr';

export default class Standalone extends Component {

  _CLASS_NAME = '.audio-player';

  audioPlayer = null;

  configure() {
    return super.configure();
  }

  initialize() {
    this.start();
    this.subscribeToEvents();
    return super.initialize();
  }

  start() {

    this.audioPlayer = Plyr.setup(
      this._CLASS_NAME,
      {
        debug: false,
        // controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'download'],
        controls: this.getControls(),
        hideControls: false,
        keyboard: {
          focused: false,
          global: false
        },
        fullscreen: {
          enabled:  false,
          fallback: false,
          iosNative: false
        }
      }
    );

    this.injectDownloadButton();

  }

  injectDownloadButton() {
    $(this._CLASS_NAME).each((index, element) => {

      let file = $(element).data('file'),
          onDelete = $(element).data('on-delete'),
          parent = $(element).prev();

      if (typeof file !== 'undefined') {

        // Inject url for downloading
        parent.find('.is-file-download-button').attr(
          'href',
          file.dataURL + '?download'
        );

        // Bind event to delete file
        parent.find('.is-file-delete-button').on('click', () => {
          onDelete();
        });

      }

    });
  }

  subscribeToEvents() {

    this.App.Events.subscribe('player.audio.scan', (event) => {
      return this.start();
    });

  }

  getControls() {
    return $('#standalone-audio-player-buttons-template').html();
  }

}